module.exports = __webpack_public_path__ + "static/media/miles-check.fb4d1af8.svg";